import { __extends } from "tslib";
import { TextField, DisplayObjectContainer as AwayDisplayObjectContainer, TextFieldAutoSize } from '@awayjs/scene';
import { DisplayObjectContainer } from '../../display/DisplayObjectContainer';
var TextLine = /** @class */ (function (_super) {
    __extends(TextLine, _super);
    function TextLine(previousLine, width, lineOffset, fitSomething, text, elementFormat) {
        var _this = _super.call(this) || this;
        var adaptee = new AwayDisplayObjectContainer();
        _this.adaptee = adaptee;
        _this._textfield = new TextField();
        _this._textfield.autoSize = TextFieldAutoSize.LEFT;
        adaptee.addChild(_this._textfield);
        _this._textfield.text = text;
        _this._previousLine = previousLine;
        if (previousLine) {
            previousLine.setNextLine(_this);
        }
        console.log('elementFormat', elementFormat);
        _this._text = text;
        _this._textBlockBeginIndex = 0;
        _this._rawTextLength = text.length;
        _this._specifiedWidth = width;
        return _this;
    }
    TextLine.prototype.setNextLine = function (value) {
        this._nextLine = value;
    };
    TextLine.prototype.setTextBlock = function (value) {
        this._textBlock = value;
    };
    TextLine.prototype.getMirrorRegion = function (mirror) {
        console.warn('[TextLine] - get textBlock not implemented');
        return null;
    };
    TextLine.prototype.flushAtomData = function () {
        console.warn('[TextLine] - get flushAtomData not implemented');
    };
    Object.defineProperty(TextLine.prototype, "textBlock", {
        get: function () {
            //console.warn('[TextLine] - get textBlock not implemented');
            return this._textBlock;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "hasGraphicElement", {
        get: function () {
            console.warn('[TextLine] - get hasGraphicElement not implemented', this._text);
            return false; //this._hasGraphicElement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "hasTabs", {
        get: function () {
            console.warn('[TextLine] - get hasTabs not implemented');
            return this._hasTabs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "nextLine", {
        get: function () {
            //console.warn('[TextLine] - get nextLine not implemented');
            return this._nextLine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "previousLine", {
        get: function () {
            //console.warn('[TextLine] - get previousLine not implemented');
            return this._previousLine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "ascent", {
        get: function () {
            //console.warn('[TextLine] - get ascent not implemented');
            return 0; //this._ascent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "descent", {
        get: function () {
            //console.warn('[TextLine] - get descent not implemented');
            return 0; //this._descent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "textHeight", {
        get: function () {
            return this._textfield.textHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "textWidth", {
        get: function () {
            //console.warn('[TextLine] - get textWidth not implemented');
            return 100; //this._textfield.textWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "totalAscent", {
        get: function () {
            console.warn('[TextLine] - get totalAscent not implemented');
            return 0; //this._totalAscent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "totalDescent", {
        get: function () {
            console.warn('[TextLine] - get totalDescent not implemented');
            return 0; //this._totalDescent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "totalHeight", {
        get: function () {
            console.warn('[TextLine] - get totalHeight not implemented');
            return 100; //this._totalHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "textBlockBeginIndex", {
        get: function () {
            //console.warn('[TextLine] - get textBlockBeginIndex not implemented');
            return this._textBlockBeginIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "rawTextLength", {
        get: function () {
            //console.warn('[TextLine] - get rawTextLength not implemented');
            return this._rawTextLength;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "specifiedWidth", {
        get: function () {
            //console.warn('[TextLine] - get specifiedWidth not implemented');
            return this._specifiedWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "unjustifiedTextWidth", {
        get: function () {
            console.warn('[TextLine] - get unjustifiedTextWidth not implemented');
            return this._unjustifiedTextWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "validity", {
        get: function () {
            //console.warn('[TextLine] - get validity not implemented');
            return this._validity;
        },
        set: function (value) {
            //console.warn('[TextLine] - set validity not implemented');
            this._validity = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "atomCount", {
        get: function () {
            console.warn('[TextLine] - get atomCount not implemented');
            return this._atomCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextLine.prototype, "mirrorRegions", {
        get: function () {
            console.warn('[TextLine] - get mirrorRegions not implemented');
            return this._mirrorRegions;
        },
        enumerable: true,
        configurable: true
    });
    TextLine.prototype.getAtomIndexAtPoint = function (stageX, stageY) {
        console.warn('[TextLine] - getAtomIndexAtPoint not implemented');
        return null;
    };
    TextLine.prototype.getAtomIndexAtCharIndex = function (charIndex /*int*/) {
        console.warn('[TextLine] - getAtomIndexAtCharIndex not implemented');
        return null;
    };
    TextLine.prototype.getAtomBounds = function (atomIndex /*int*/) {
        console.warn('[TextLine] - getAtomBounds not implemented');
        return null;
    };
    TextLine.prototype.getAtomBidiLevel = function (atomIndex /*int*/) {
        console.warn('[TextLine] - getAtomBidiLevel not implemented');
        return null;
    };
    TextLine.prototype.getAtomTextRotation = function (atomIndex /*int*/) {
        console.warn('[TextLine] - getAtomTextRotation not implemented');
        return null;
    };
    TextLine.prototype.getAtomTextBlockBeginIndex = function (atomIndex /*int*/) {
        console.warn('[TextLine] - getAtomTextBlockBeginIndex not implemented');
        return null;
    };
    TextLine.prototype.getAtomTextBlockEndIndex = function (atomIndex /*int*/) {
        console.warn('[TextLine] - getAtomTextBlockEndIndex not implemented');
        return null;
    };
    TextLine.prototype.getAtomCenter = function (atomIndex /*int*/) {
        console.warn('[TextLine] - getAtomCenter not implemented');
        return null;
    };
    TextLine.prototype.getAtomWordBoundaryOnLeft = function (atomIndex /*int*/) {
        console.warn('[TextLine] - getAtomWordBoundaryOnLeft not implemented');
        return null;
    };
    TextLine.prototype.getAtomGraphic = function (atomIndex /*int*/) {
        console.warn('[TextLine] - getAtomGraphic not implemented');
        return null;
    };
    TextLine.prototype.getBaselinePosition = function (baseline) {
        //console.warn('[TextLine] - getBaselinePosition not implemented');
        return 0;
    };
    TextLine.prototype.dump = function () {
        console.warn('[TextLine] - dump not implemented');
        return null;
    };
    TextLine.forceNativeConstructor = true;
    TextLine.forceNativeMethods = true;
    TextLine.MAX_LINE_WIDTH = 1000000;
    return TextLine;
}(DisplayObjectContainer));
export { TextLine };
